import React from 'react';
import useAuth from 'context/useAuth';
import useFormFields from 'hooks/useFormFields';

import AccountVerificationPage from './AccountVerificationPage';
import LoginPage from './LoginPage';

const AuthenticationPage = () => {
    const { forgotCredsUsername, userMFASession } = useAuth();
    const { formFields, setFormField } = useFormFields({
        password: '',
        username: {
            isValid: forgotCredsUsername ? true : null,
            value: forgotCredsUsername || '',
        },
    });
    const { password, username } = formFields;

    return !userMFASession ? (
        <LoginPage password={password} setFormField={setFormField} username={username} />
    ) : (
        <AccountVerificationPage password={password} username={username} />
    );
};

export default AuthenticationPage;
